/* eslint-disable default-case */
const _ = require('lodash')

const buildStepName = (tournament, step, index) => {
  switch (step) {
    case 'checkin': {
      return 'Check In'
    }
    case 'pools_arrangement': {
      const name = tournament?.[`pool_name_${index}`]

      if (!_.isNil(name)) {
        return `Setup ${name}`
      }

      return 'Squadrons Setup'
    }
    case 'pools': {
      const name = tournament?.[`pool_name_${index}`]

      if (!_.isNil(name)) {
        return name
      }

      return 'Squadrons'
    }
    case 'table': {
      const name = tournament?.[`table_name_${index}`]

      if (!_.isNil(name)) {
        return name
      }

      return 'Eliminations'
    }
    case 'bestof': {
      const name = tournament?.[`table_name_${index}`]

      if (!_.isNil(name)) {
        return name
      }

      return 'Best of Round'
    }
    case 'final': {
      return 'Results'
    }
  }
}

export {
  buildStepName
}
